import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import ErrorComponent from './components/Error';
import {SharedContextURLProvider, useSharedURLContext} from '@mediassistrepo/shared-context'

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <SharedContextURLProvider>
    <Provider store={store}>
      <BrowserRouter>
      <ErrorBoundary FallbackComponent={ErrorComponent} >
        <App />
      </ErrorBoundary>
      </BrowserRouter>
    </Provider>
    </SharedContextURLProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
